import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SafetyCard from "./pages/StartScreen/StartScreen";
import Verification from "./pages/verification/Verification";
import ProfileDetailsPage from "./pages/Profilepage/profile";
import ReportPage from "./pages/Reportingpage/report";
import RecorderPage from "./pages/Reportingpage/RecorderPage";
import ThankYouScreen from "./pages/Reportingpage/ThankYouScreen";
import AddFingerprint from "./pages/AddFingerprint/addfinger";
import AddAdminFingerprint from "./pages/AddadminFinger/AddAdminFingerprint";
 
 
export default function App() {
  useEffect(() => {
    const artW = 768;
    const artH = 1366;
 
    function setScale() {
      const scale = Math.min(
        window.innerWidth / artW,
        window.innerHeight / artH
      );
      document.documentElement.style.setProperty("--scale", scale);
    }
 
    // 🔒 Disable right-click
    const disableRightClick = (e) => e.preventDefault();
 
    setScale();
    window.addEventListener("resize", setScale);
    document.addEventListener("contextmenu", disableRightClick);
 
    return () => {
      window.removeEventListener("resize", setScale);
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);
 
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SafetyCard />} />
        <Route path="/verify" element={<Verification />} />
        <Route path="/profile" element={<ProfileDetailsPage />} />
        <Route path="/report" element={<ReportPage />} />
        <Route path="/recorder" element={<RecorderPage />} />
        <Route path="/thank-you" element={<ThankYouScreen />} />
        <Route path="/add-fingerprint" element={<AddFingerprint />} />
        <Route path="/admin-fingerprint" element={<AddAdminFingerprint />} />
      </Routes>
    </Router>
  );
}